<template>
	<v-container fill-height>
		<v-layout text-xs-center row wrap class="contact-container">
			<v-flex xs12 sm5 order-xs2 order-sm1>
				<v-carousel
					hide-delimiters
					hide-controls
					interval="4000"
					height="80vh"
				>
					<v-carousel-item
						v-for="(image, index) in carouselImages"
						:src="image.src"
						:key="index"
					></v-carousel-item>
				</v-carousel>
			</v-flex>

			<v-flex xs12 sm5 offset-sm1 order-xs1 order-sm2>
				<h1 class="display-1 font-weight-bold mb-3">Jennifer Bauhn</h1>
				<p
					class="title font-weight-thin font-italic"
					v-html="aboutText"
				></p>
				<p class="body-1" v-html="aboutText2"></p>
				<v-btn
					v-for="(sm, index) in socialMedias"
					:key="index"
					:href="sm.link"
					target="_blank"
					class="mx-3 white--text"
					icon
				>
					<font-awesome-icon :icon="sm.icon" size="2x" />
				</v-btn>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			socialMedias: [
				// { icon: ['fab', 'twitter'], link: 'https://twitter.com/bauhn' },
				{
					icon: ['fab', 'instagram'],
					link: 'https://www.instagram.com/bauhn.makeup/'
				}
				// { icon: ['fab', 'tumblr'], link: 'http://bauhn-makeup.tumblr.com/' }
			],

			carouselImages: [{ src: '1.jpg' }, { src: '2.jpg' }, { src: '3.jpg' }],
			aboutText: `Certifierad make up artist vid International Make up Center sedan 2011. <br />
			Baserad i Borås / Göteborg men är tillgänglig för resa inom hela landet. <br /> <br />
Erbjuder alla typer av make up vid event, bröllop, bal och fotograferingar både för företag och privatpersoner. Även övriga tjänster som tex färgning och formning av ögonbryn och ögonfransar. `,
			aboutText2: `För frågor och prisinformation, vänligen kontakta mig. <br />

Jennifer Bauhn <br />
+46708195777 <br />
jennifer@bauhn.se`
		}
	}
}
</script>

<style scoped>
.contact-container {
	align-items: center;
	justify-content: center;
}
</style>
